import { render, staticRenderFns } from "./IconLibrary.vue?vue&type=template&id=7d5d8765&"
import script from "./IconLibrary.vue?vue&type=script&lang=js&"
export * from "./IconLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d5d8765')) {
      api.createRecord('7d5d8765', component.options)
    } else {
      api.reload('7d5d8765', component.options)
    }
    module.hot.accept("./IconLibrary.vue?vue&type=template&id=7d5d8765&", function () {
      api.rerender('7d5d8765', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconLibrary.vue"
export default component.exports